/** Adresse de contact pour le catalogue full (lien mailto standard). */
export const CATALOG_CONTACT_EMAIL = 'eliott.forin@gmail.com';

/** Ouvre le client mail par défaut de l'utilisateur (Mail, Outlook, Gmail, etc.). */
export function getCatalogContactMailto() {
  const params = new URLSearchParams({
    subject: 'Demande — Catalogue OTR Studio',
  });
  return `mailto:${CATALOG_CONTACT_EMAIL}?${params.toString()}`;
}
